import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // This will be for Tailwind CSS
import App from "./App";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If react-snap prerendered static HTML, hydrate it; otherwise render fresh.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
